module.exports = __webpack_public_path__ + "img/facebook.dbedf994.png";